import { render } from "./DirectoryLayout.vue?vue&type=template&id=81474496&scoped=true&ts=true"
import script from "./DirectoryLayout.vue?vue&type=script&lang=ts"
export * from "./DirectoryLayout.vue?vue&type=script&lang=ts"

import "./DirectoryLayout.vue?vue&type=style&index=0&id=81474496&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81474496"]])

export default __exports__